/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Grid,
  Dialog,
  Typography,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Snackbar,
} from "@mui/material";
import { Cancel, Close } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useMaterialUIController } from "context";
import MDBox from "components/MDBox";
import { createTheme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import { MenuProps } from "utils/constants";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

const defaultValue = {
  name: "",
  note: "",
  group_menu: "",
  url: "",
};

const CRUDMenu = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  validationErrors,
  dataGroupMenu,
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [dataState, setDataState] = useState(defaultValue);
  const formRef = useRef(null);
  const axiosPrivateInstance = useAxiosPrivate();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.info.main,
      },
      background: {
        default: colors.background.default,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.info.main,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  const [errors, setErrors] = useState({
    name: "",
    group_menu: "",
    url: "",
  });
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors([]);
    }
  }, [open]);
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    // <ThemeProvider theme={darkMode ? themeDark : themeLight}>
    <Dialog open={open} maxWidth={"md"}>
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Danh sách Chức năng"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <DialogContent dividers>
          <MDBox sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} sx={{ textAlign: "left" }}>
              <Grid item xs={12} md={12} lg={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="label-nam">Nhóm Menu</InputLabel>
                  <Select
                    label="Nhóm Menu"
                    sx={{ padding: "0.7rem" }}
                    labelId="label-loai"
                    value={dataState.group_menu || 0}
                    MenuProps={MenuProps}
                    onChange={handleChangeValueInput("group_menu")}
                  >
                    <MenuItem value="0">Tất cả</MenuItem>
                    {dataGroupMenu &&
                      dataGroupMenu?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tên Chức năng <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  value={dataState.name || ""}
                  sx={{ width: "100%" }}
                  name="name"
                  error={errors ? !!errors.name : false}
                  helperText={errors.name}
                  onFocus={handleOnFocus("name")}
                  onChange={handleChangeValueInput("name")}
                  placeholder="Nhập Tên Chức năng"
                  inputProps={{ maxLength: 255 }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  URL Link <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  value={dataState.url || ""}
                  sx={{ width: "100%" }}
                  name="name"
                  error={errors ? !!errors.url : false}
                  helperText={errors.url}
                  onFocus={handleOnFocus("url")}
                  onChange={handleChangeValueInput("url")}
                  placeholder="Nhập URL Link"
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Ghi chú
                </Typography>
                <TextField
                  fullWidth
                  name="note"
                  error={errors ? !!errors.note : false}
                  helperText={errors?.note}
                  value={dataState ? dataState.note : ""}
                  onChange={handleChangeValueInput("note")}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      note: "",
                    });
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
    // </ThemeProvider>
  );
};
const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    name: !validateRequired(user.name) ? "Tên Chức năng không được trống" : "",
    url: !validateRequired(user.url) ? "Đường dẫn URL không được trống" : "",
  };
}

export default CRUDMenu;
